import React from 'react';
import PropTypes from 'prop-types';
import colors from '@toolshed/styleguide/styles/colors';

class Spinner extends React.Component {
  constructor(props) {
    super(props);

    const { radius, stroke } = props;

    this.normalizedRadius = radius - stroke * 2;
    this.circumference = this.normalizedRadius * 2 * Math.PI;
  }

  render() {
    const { Circle, progress, mask } = this.props;

    const strokeDashoffset =
      this.circumference - (progress / 100) * this.circumference;

    return (
      <Circle
        stroke={colors.blue}
        strokeDasharray={`${this.circumference} ${this.circumference}`}
        strokeLinecap="butt"
        style={{
          strokeDashoffset,
          transform: 'rotate(-4deg)',
          transformOrigin: '50% 50%',
        }}
        mask={mask}
      />
    );
  }
}

Spinner.propTypes = {
  radius: PropTypes.number,
  stroke: PropTypes.number,
  progress: PropTypes.number,
  mask: PropTypes.any,
  Circle: PropTypes.any,
};

export default Spinner;
